import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ShipInfoState extends UltMeta {
    CERTIFIED = new Meta(1, "已认证", "tip");
    UN_CERTIFIED = new Meta(0, "未认证", "info");
}
export const SHIP_INFO_STATE = new ShipInfoState();

// 船舶状态
class ShipSailStatus extends UltMeta {
    UNDER_WAY_USING_ENGINE = new Meta("0", "发动机使用中");
    AT_ANCHOR = new Meta("1", "锚泊");
    NOT_UNDER_COMMAND = new Meta("2", "未操作");
    RESTRICTED_MANEUVERABILITY = new Meta("3", "操纵能力受限");
    CONSTRAINED_BY_HER_DRAUGHT = new Meta("4", "吃水受限");
    MOORED = new Meta("5", "系泊");
    AGROUND = new Meta("6", "搁浅");
    ENGAGED_IN_FISHING = new Meta("7", "从事捕捞");
    UNDER_WAY_SAILING = new Meta("8", "航行中");
    SAVE_FOR_FUTURE_CORRECTION_NAVIGATION_STATUS = new Meta("9", "留作将来修正导航状态");
    RESERVED_FOR_HSC = new Meta("10", "高速船留用");
    MOTOR_PUSH_OPERATION = new Meta("11", "机动船尾推作业");
    POWER_BOAT_PUSH_OR_SIDE_PUSH_OPERATION = new Meta("12", "机动船顶推或侧推作业");
    RESERVED_FOR_WIG = new Meta("13", "飞翼船留用");
    CURRENT = new Meta("14", "现行的");
    NOT_DEFINED = new Meta("15", "未定义");
}
export const SHIP_SAIL_STATUS = new ShipSailStatus();

// 船舶类型
class ShipType extends UltMeta {
    WIG = new Meta(1, "飞翼船");
    FISHING_VESSEL = new Meta(2, "捕捞船");
    TUG = new Meta(3, "拖带船");
    SAILBOATS = new Meta(4, "帆船");
    YACHT = new Meta(5, "游艇");
    HSC = new Meta(6, "高速船");
    NAVIGATION_SHIP = new Meta(7, "领航船");
    SEARCH_AND_RESCUE_SHIP = new Meta(8, "搜救船");
    TUGBOAT = new Meta(9, "拖轮");
    PORT_SUPPLY = new Meta(10, "港口供应");
    ANTI_POLLUTION_VESSEL = new Meta(11, "防污船舶");
    LAW_ENFORCEMENT_VESSEL = new Meta(12, "执法船");
    MEDICAL_TRANSPORT = new Meta(13, "医疗运输");
    SPECIAL_SHIPS = new Meta(14, "特殊船");
    PASSENGER_SHIPS = new Meta(15, "客轮");
    CARGO_SHIPS = new Meta(16, "货轮");
    TANKER = new Meta(17, "油轮");
    CONTAINER_SHIP = new Meta(18, "集装箱船");
    OTHER = new Meta(19, "其他");
    UNKNOWN = new Meta(20, "未知");
}
export const SHIP_TYPE = new ShipType();

class AisShipType extends UltMeta {
    WIG = new Meta(1, "飞翼船");
    FISHING_VESSEL = new Meta(2, "捕捞船");
    TUG = new Meta(3, "拖带船");
    SAILBOATS = new Meta(4, "帆船");
    YACHT = new Meta(5, "游艇");
    HSC = new Meta(6, "高速船");
    NAVIGATION_SHIP = new Meta(7, "领航船");
    SEARCH_AND_RESCUE_SHIP = new Meta(8, "搜救船");
    TUGBOAT = new Meta(9, "拖轮");
    PORT_SUPPLY = new Meta(10, "港口供应");
    ANTI_POLLUTION_VESSEL = new Meta(11, "防污船舶");
    LAW_ENFORCEMENT_VESSEL = new Meta(12, "执法船");
    MEDICAL_TRANSPORT = new Meta(13, "医疗运输");
    SPECIAL_SHIPS = new Meta(14, "特殊船");
    PASSENGER_SHIPS = new Meta(15, "客船");
    CARGO_SHIPS = new Meta(16, "货船");
    TANKER = new Meta(17, "油轮");
    CONTAINER_SHIP = new Meta(18, "集装箱船");
    OTHER = new Meta(19, "其他");
    UNKNOWN = new Meta(20, "未知");
}
/** 船舶类型,实际业务ais信息内类型的货轮实际上是货船,客轮同理 */
export const AIS_SHIP_TYPE = new AisShipType();

// 识别状态
class RecognizeResult extends UltMeta {
    LOADING = new Meta(0, "装载中");
    UNLOADING = new Meta(1, "卸货中");
    LOADED = new Meta(2, "满载");
    IDLE = new Meta(3, "空载");
    UNKNOWN = new Meta(4, "未知");
}
export const RECOGNIZE_RESULT = new RecognizeResult();

// 船舶码
class ShipCodeColor extends UltMeta {
    RED = new Meta(1, "红码");
    YELLOW = new Meta(2, "黄码");
    BLUE = new Meta(3, "蓝码");
    GREEN = new Meta(4, "绿码");
}
export const SHIP_CODE_COLOR = new ShipCodeColor();

class CanopyState extends UltMeta {
    OPEN = new Meta(1, "棚架开启");
    CLOSE = new Meta(2, "棚架关闭");
    UNKNOWN = new Meta(0, "未知");
}
export const CANOPY_STATE = new CanopyState();
